import { jwtDecode } from 'jwt-decode';
import { Variables } from '../configs/appConfigs';
import LocalStorageService from './localStorageService';

export const setTokensInStorage = (tokens) => {
  if (tokens && tokens.rtk) {
    LocalStorageService.set(Variables.accessToken, tokens.atk);
    LocalStorageService.set(Variables.refreshToken, tokens.rtk);
  }
};

export const parseJWTToken = (token: string): Record<string, any> => {
  return jwtDecode(token);
};
